import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.css';

const Room = ({
  id,
  title,
  subtitle,
  icon,
  className,
  url,
  descriptionClassName,
  timelineIconClassName
}) => {

  const elemId = title?.replace(/ /g, '_').toLowerCase();

  return (
    <div
      id={id || elemId}
      className={`${className} ${styles.timelineRoom}`}>
      <div
        className={`${timelineIconClassName} ${styles.timelineRoomIcon}`}
        title={`${title} - ${subtitle}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.12 42.12">
          <g>
            <g>
              <g>
                <path
                  d="M29.51,26.65a2.75,2.75,0,0,0,2-.87,3,3,0,0,0,.88-2v-4a3,3,0,0,0-3-3,3,3,0,0,0-2.12.88,2.86,2.86,0,0,0-.88,2.12v2.76m-10.64,0V19.78a2.86,2.86,0,0,0-.88-2.12,3,3,0,0,0-4.24,0,2.89,2.89,0,0,0-.87,2.12v4a2.89,2.89,0,0,0,.87,2,2.82,2.82,0,0,0,2,.87m.13,0h-.06m.13,0H13m16.33,0h-.17m.24,0h.07M15.74,22.54H26.38m-13.7,4.11h-.07m.13,0h.07m.17,0H29.14m.24,0h-.07m.14,0h.06"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
                />
                <path
                  d="M26.23,9.75a2.93,2.93,0,0,1,2,.88,2.88,2.88,0,0,1,.87,2.11v3.68M26,9.75h-.18m-9.78,0h.18m-.24,0H16m-.06,0a3,3,0,0,0-2,.88A2.88,2.88,0,0,0,13,12.74v3.68M26.1,9.75h.07m-.31,0h-9.6m-.24,0h.06m-.13,0h-.06m10.28,0h.06m-.13,0H26"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
                />
                <path
                  d="M41.12,21.08a19.27,19.27,0,0,1-5.87,14.17,19.27,19.27,0,0,1-14.17,5.87A19.32,19.32,0,0,1,6.87,35.25,19.31,19.31,0,0,1,1,21.08,19.36,19.36,0,0,1,6.87,6.87,19.36,19.36,0,0,1,21.08,1,19.31,19.31,0,0,1,35.25,6.87,19.32,19.32,0,0,1,41.12,21.08Z"
                  style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
                />
                <g>
                  <path
                    d="M13.2,27.26v5.43H16l2-5.43"
                    style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
                  />
                  <path
                    d="M24.13,27.26l2,5.43h2.81V27.26"
                    style={{ fill: 'none', stroke: '#000', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2px' }}
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div className={`${descriptionClassName} ${styles.timelineRoomWrapperTitle}`}>
        {title && <div className={styles.timelineRoomTitle}>{title}</div>}
        {subtitle && <div className={styles.timelineRoomSubTitle}>{subtitle}</div>}
      </div>
    </div>
  );
}

Room.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  timelineIconClassName: PropTypes.string,
  descriptionClassName: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  url: PropTypes.string,
};

export default Room;